export interface ProcessingTimeFormProfile {
  processingTime: number
}

export const defaultValues: ProcessingTimeFormProfile = {
  processingTime: 1,
}
